namespace $.$$ {
	$mol_style_define( $bog_merchquarium_gallery, {
		display: 'grid',
		gridTemplateColumns: 'repeat( auto-fill, minmax( min( 16rem, 100% ), 1fr ) )',
		gap: $mol_gap.block,
		padding: $mol_gap.block,
		alignItems: 'start',
	} )

}
